const Footer = () => {
  return (
    <div className="footer-wrapper">
      <span className="footer-trademark-text">
        © Copyright STADA Arzneimittel AG 2024
      </span>
    </div>
  );
};

export default Footer;
